import type { CostUnit } from '../model/types'

export interface CatalogProduct {
  name: string
  /** Единица по умолчанию — подставляется при выборе из списка. */
  unit: CostUnit
}

/**
 * Заготовленный список популярных кондитерских продуктов.
 * Не ограничивает пользователя: своё название можно вписать руками, список
 * лишь ускоряет ввод и подставляет подходящую единицу измерения.
 *
 * Порядок — по группам (бакалея, молочка, шоколад и т.д.), внутри групп по
 * частоте использования. Правится вручную, на бэк не ходит.
 */
export const PRODUCT_CATALOG: readonly CatalogProduct[] = [
  // Бакалея
  { name: 'Мука пшеничная', unit: 'г' },
  { name: 'Мука миндальная', unit: 'г' },
  { name: 'Сахар', unit: 'г' },
  { name: 'Сахарная пудра', unit: 'г' },
  { name: 'Соль', unit: 'г' },
  { name: 'Крахмал кукурузный', unit: 'г' },
  { name: 'Разрыхлитель', unit: 'г' },
  { name: 'Сода', unit: 'г' },
  { name: 'Какао-порошок', unit: 'г' },
  { name: 'Желатин', unit: 'г' },
  { name: 'Агар-агар', unit: 'г' },
  { name: 'Ванильный экстракт', unit: 'мл' },
  { name: 'Ванильный сахар', unit: 'г' },

  // Молочные продукты и яйца
  { name: 'Яйца', unit: 'шт' },
  { name: 'Желтки', unit: 'шт' },
  { name: 'Белки', unit: 'шт' },
  { name: 'Молоко', unit: 'мл' },
  { name: 'Сливки 33%', unit: 'мл' },
  { name: 'Сливки 10%', unit: 'мл' },
  { name: 'Масло сливочное', unit: 'г' },
  { name: 'Сыр творожный', unit: 'г' },
  { name: 'Маскарпоне', unit: 'г' },
  { name: 'Сметана', unit: 'г' },
  { name: 'Творог', unit: 'г' },
  { name: 'Сгущённое молоко', unit: 'г' },
  { name: 'Сухое молоко', unit: 'г' },

  // Шоколад и глазури
  { name: 'Шоколад тёмный', unit: 'г' },
  { name: 'Шоколад молочный', unit: 'г' },
  { name: 'Шоколад белый', unit: 'г' },
  { name: 'Какао-масло', unit: 'г' },
  { name: 'Глазурь', unit: 'г' },

  // Орехи и сухофрукты
  { name: 'Фисташка', unit: 'г' },
  { name: 'Фундук', unit: 'г' },
  { name: 'Миндаль', unit: 'г' },
  { name: 'Грецкий орех', unit: 'г' },
  { name: 'Арахисовая паста', unit: 'г' },
  { name: 'Фисташковая паста', unit: 'г' },

  // Фрукты и ягоды
  { name: 'Малина', unit: 'г' },
  { name: 'Клубника', unit: 'г' },
  { name: 'Вишня', unit: 'г' },
  { name: 'Чёрная смородина', unit: 'г' },
  { name: 'Банан', unit: 'шт' },
  { name: 'Лимон', unit: 'шт' },
  { name: 'Пюре фруктовое', unit: 'г' },

  // Прочее
  { name: 'Мёд', unit: 'г' },
  { name: 'Сироп глюкозы', unit: 'г' },
  { name: 'Растительное масло', unit: 'мл' },
  { name: 'Мастика', unit: 'г' },
  { name: 'Краситель гелевый', unit: 'г' },
  { name: 'Кофе растворимый', unit: 'г' },

  // Упаковка и расходники — тоже часть себестоимости
  { name: 'Коробка для торта', unit: 'шт' },
  { name: 'Подложка', unit: 'шт' },
  { name: 'Свечи / топперы', unit: 'шт' },
]
